module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"camera":"camera","mic":"mic","speaker":"speaker","Select a":"Select a {0}"},"zh":{"camera":"摄像头","mic":"麦克风","speaker":"扬声器","Select a":"请选择{0}"}}')
  delete Component.options._Ctor
}
